<template>
    <div class="flex flex-grow h-0 py-2">
        <div class="flex flex-col h-full w-full px-2">
            <card-form
                :meta="counteragentFormMeta"
                components-path="views/counteragents/counteragent-version-card/components"
                :callbacks="{refreshData: refreshData, saveData: saveData, isDirty: null}"
            />
        </div>
    </div>
</template>

<script setup>
import cardForm from '@/components/card-component/card-form.vue';
import counteragentFormMeta from '@/views/counteragents/counteragent-version-card/card-meta';
import {getCustomerVersCard, saveCustomerVersCard} from "@/service/counteragent-vers-service";
import { useRoute } from 'vue-router';

const route = useRoute();
const refreshData = async () => {
  return await getCustomerVersCard(route.params.id)
}

const saveData = async (data) => {
  console.log(`contragent-card-vers: saveData: data: ${JSON.stringify(data)}`)
  // // добавить сохранение в базу

  const { result, error } = await saveCustomerVersCard(data) // await saveById(save_args)

  if (!result)
    alert(error)
  //else
  //    refresh()

  return result;
};

// TODO: перенести логику пересчета заголовка для группы статус на основу стора userDataDetails.userData.data
// const counteragentFormMetaRef = ref(counteragentFormMeta);
// watch(data, () => {
//     if (data && data.status) {
//         counteragentFormMetaRef.value.groups = counteragentFormMetaRef.value.groups.map(item =>
//             item.id == 2 ? { ...item, label: `Статус ${data.status.value}` } : item
//         );
//     }
// });
</script>
